import RewardListPanel from './rewardListPanel.container';

export default RewardListPanel